module.exports = __webpack_public_path__ + "static/img/gongbaojiding.bf366d38.png";